// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayrollCalendarReducedDto
 */
export interface IPayrollCalendarReducedDto {
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarReducedDto
     */
    calendar_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarReducedDto
     */
    calendar_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPayrollCalendarReducedDto
     */
    already_used?: boolean;
}

/**
 * Check if a given object implements the IPayrollCalendarReducedDto interface.
 */
export function instanceOfIPayrollCalendarReducedDto(value: object): value is IPayrollCalendarReducedDto {
    return true;
}

export function IPayrollCalendarReducedDtoFromJSON(json: any): IPayrollCalendarReducedDto {
    return IPayrollCalendarReducedDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarReducedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarReducedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_id': json['calendar_id'] == null ? undefined : json['calendar_id'],
        'calendar_name': json['calendar_name'] == null ? undefined : json['calendar_name'],
        'already_used': json['already_used'] == null ? undefined : json['already_used'],
    };
}

export function IPayrollCalendarReducedDtoToJSON(json: any): IPayrollCalendarReducedDto {
    return IPayrollCalendarReducedDtoToJSONTyped(json, false);
}

export function IPayrollCalendarReducedDtoToJSONTyped(value?: IPayrollCalendarReducedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendar_id': value['calendar_id'],
        'calendar_name': value['calendar_name'],
        'already_used': value['already_used'],
    };
}

